'use client';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";
import React, { useEffect, useState } from "react";
import Image from 'next/image'

import useMobileDetect from "@/hooks/useMobileDetect";
import Global from "@/utils/global";

import "swiper/css";
import "swiper/css/pagination";
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import "./index.css";
import userInfoStore from "@/store/userInfoStore";

import { handleCardClick } from "@/utils/tools";

const Index: React.FC<{ isFirstMobile: boolean, bannerList: any[] }> = ({ isFirstMobile = false, bannerList = [] }) => {

  const isMobile = useMobileDetect(isFirstMobile);
  const { userInfo } = userInfoStore()
  const [height, setHeight] = useState<number>(isMobile ? 662 : 840)
  const [current, setCurrent] = useState<number>(-1);
  const [bulletActiveClass, setBulletActiveClass] = useState<string>('current');
  // const [carouselArr, setCarouselArr] = useState([
  //   {
  //     title: "1",
  //     pc: Global.imageUrl + "static/web/1.2.1/pc/pc-carousel-img1.webp",
  //     h5: Global.imageUrl + "static/web/1.2.1/h5/h5-carousel-img1.webp",
  //     h5_blur: "",
  //     isShow: true,
  //   },
  //   {
  //     title: "2",
  //     pc: Global.imageUrl + "static/web/1.2.1/pc/pc-carousel-img2.webp",
  //     h5: Global.imageUrl + "static/web/1.2.1/h5/h5-carousel-img2.webp",
  //     pc_blur: "",
  //     h5_blur: "",
  //     isShow: userInfo?.email ? false : true,
  //   },
  // ])
  const carouselArr = bannerList.map(item => {
    return {
      title: item.pic_name || item.alt_text,
      pc: Global.imageUrl + item.pc_pic,
      h5: Global.imageUrl + item.h5_pic,
      isShow: true,
      ...item
    }
  })

  const pagination = {
    el: isMobile ? '.swiper-pagination' : null,
    clickable: true
  };

  // useEffect(() => {
  //   if (carouselArr.length > 1) {
  //     carouselArr[1].isShow = userInfo?.email ? false : true;
  //     setCarouselArr([...carouselArr.filter(item => item.isShow)])
  //   }
  // }, [userInfo?.email])

  const onSlideChange = (item: any) => {
    const index = item.realIndex || 0;

    // 设置轮播图导航动画样式
    setCurrent(index);
  }

  const Pagination = () => <div style={{ position: 'absolute', bottom: '16px', left: 0, width: '100%', textAlign: 'center', zIndex: 1 }}>
    {carouselArr.map((_item, index: number) => {
      {/* 给当前幻灯片加入特殊的 class */ }
      return <span key={index} className={'custom-swiper ' + (current === index ? bulletActiveClass : ' ')}></span>
    })}
  </div>;


  useEffect(() => {
    const width = globalThis.innerWidth;

    if (width) {
      if (isMobile) {
        setHeight(width * 1800 / 1125)
      } else {
        setHeight(width * 1680 / 2880)
      }
    }

  }, [globalThis.innerWidth, isMobile])

  const onVisibilitychange = () => {
    // 页面 不在可视区域，自动关闭轮播动画
    setBulletActiveClass(!document.hidden ? 'current' : ' ');
  }

  useEffect(() => {
    document.addEventListener("visibilitychange", onVisibilitychange)
    setCurrent(0)
    return () => {
      document.removeEventListener("visibilitychange", onVisibilitychange)
    }
  }, [])

  return <div className="IndexCarousel" style={{
    position: 'relative', width: '100%', paddingBottom: isMobile ? `calc(1800 / 1125 * 100%)` : `calc(1680 / 2880 * 100%)`,
    backgroundSize: '100%', backgroundImage: `url(${isMobile ? carouselArr[0].h5 : carouselArr[0].pc})`
  }}>
    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
      <Swiper
        // aspect-3/2
        className="h-full amdClass md:amdClass"
        pagination={pagination}
        modules={[Pagination, Autoplay].concat(carouselArr.length > 1 ? [Navigation] : [])}
        navigation={carouselArr.length > 1 ? true : false}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        effect='fade'
        fadeEffect={{
          crossFade: true
        }}
        loop={carouselArr.length > 1 ? true : false}
        speed={1500}
        direction='horizontal'
        onSlideChange={onSlideChange}
      >
        {carouselArr.filter(item => item.isShow).map((item, idx: number) => (
          <SwiperSlide key={item.title}>
            {/* // aspect-3/2 */}
            <div className="w-full h-full">
              {
                handleCardClick({...item, idx}, <Image
                  src={isMobile ? item.h5 : item.pc}
                  width={0}
                  height={0}
                  // sizes="100vw"
                  // aspect-3/2
                  className="w-full h-full"
                  alt={item.alt_text}
                />, isMobile)
              }
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
    {/* <div className="swiper-pagination"></div> */}
    {carouselArr.length > 1 ? <Pagination /> : null}
  </div>
}



export default Index